"use client";
import "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { useThemeStore } from "../../stores/theme/useThemeStore.js";
import { AuthMainStepContent } from "./AuthMainStepContent.js";
import { CenteredText } from "../common.js";
const AuthMainStep = ({ oAuthMethods, disableEmailLogin, disablePhoneLogin }) => {
  const logo = useThemeStore((state) => state.getLogo());
  const appName = useThemeStore((state) => state.appName);
  const authLayout = useThemeStore((state) => state.authLayout);
  const embeddedModal = useThemeStore((state) => state.embeddedModal);
  const firstLayoutType = authLayout[0].split(":")[0];
  const heading = firstLayoutType === "AUTH" ? "Sign Up or Login" : "Connect Wallet";
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    logo && /* @__PURE__ */ jsx(Logo, { src: logo, alt: `${appName ? `${appName} -` : ""}logo` }),
    !embeddedModal && /* @__PURE__ */ jsx(CenteredText, { variant: logo ? "bodyM" : "headingS", weight: "semiBold", children: heading }),
    /* @__PURE__ */ jsx(
      AuthMainStepContent,
      {
        disableEmailLogin,
        disablePhoneLogin,
        oAuthMethods
      }
    )
  ] });
};
const Logo = styled.img`
  height: 100px;
  max-width: 260px;
  object-fit: contain;
  box-sizing: content-box;
  align-self: center;
`;
export {
  AuthMainStep
};
